import Enum from '/@/modules/core/app/helpers/Enum';

export class OwnedTaxType extends Enum {
  static PAYABLE = {
    key: 'payable_tax',
    value: 'Payable'
  };

  static REFUND = {
    key: 'refund_tax',
    value: 'Refund'
  };
}
